import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

export const ResetPasswordPopup = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Kennwort zurücksetzen
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Wir senden Ihnen alle Informationen zur Wiederherstellung Ihres
          Passwortes, check deine E-Mails.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};
